import { render, staticRenderFns } from "./CompanyIncorporationTab.vue?vue&type=template&id=6be88d30&scoped=true&"
import script from "./CompanyIncorporationTab.vue?vue&type=script&lang=js&"
export * from "./CompanyIncorporationTab.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIncorporationTab.vue?vue&type=style&index=0&id=6be88d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be88d30",
  null
  
)

export default component.exports